import React from 'react'
import { setFormCreateReturnTo } from '~/pages/cp/forms/formCreateReturnTo'

/**
 * Link from the landing page Form (embedded) block into the form create flow.
 * Stores a return URL so step 6 can send the user back to this landing page.
 */
export default function CreateEmbeddedFormLink(props) {
    const landingPageId = props.landingPageId

    const onClick = (event) => {
        event.preventDefault()
        if (landingPageId) {
            setFormCreateReturnTo(`/cp/templates/add/dragDropv2/?landingPageId=${landingPageId}`)
        }
        if (props.saveTemplate) {
            props.saveTemplate(false, undefined, false, true)
        }
        window.open('/cp/forms', '_self')
    }

    return (
        <div className='text-xsml mar-b15'>
            Or{' '}
            <a href='/cp/forms' onClick={onClick}>
                Create a new form
            </a>
        </div>
    )
}
